<script>
export default {
  props: ['active'],
};
</script>

<template lang="pug">
div(:class="[$style.root, active && $style.active]")
  slot
</template>

<style module lang="sass">
.root
  font-size: $title_size
  font-weight: 400
  text-transform: uppercase
  white-space: nowrap
  padding: 0 16px
  line-height: 36px
  height: 36px
  cursor: pointer
  box-sizing: border-box
  transition: color $a_speed, border-color $a_speed
  color: $color_text_second
  border-bottom: 3px solid transparent
  &:hover
    color: $color_text
.active
  color: $color_text
  border-color: $color_main
  cursor: default

</style>
